import { render, staticRenderFns } from "./TimelineMarkers.vue?vue&type=template&id=2ba80516&scoped=true"
import script from "./TimelineMarkers.vue?vue&type=script&lang=js"
export * from "./TimelineMarkers.vue?vue&type=script&lang=js"
import style0 from "./TimelineMarkers.vue?vue&type=style&index=0&id=2ba80516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba80516",
  null
  
)

export default component.exports